export function excelEnvironmentReportColumns() {
  const year = { key: 'year', header: 'År', width: 10 }
  const regNo = { key: 'regNo', header: 'Regnr', width: 15 }
  const vehicleID = { key: 'vehicleID', header: 'Kjøretøy ID', width: 15 }
  const invoiceGroup = { key: 'invoiceGroup', header: 'Fakturagruppe', width: 25 }
  const carDescription = { key: 'carDescription', header: 'Objekt', width: 40 }
  const totalKm = { key: 'totalKm', header: 'Kilometer', width: 15 }
  const volume = { key: 'volume', header: 'Liter', width: 15 }
  const fuelType = { key: 'fuelType', header: 'Drivstoff', width: 15 }
  const litersPerTenKm = { key: 'fuelConsumptionL10KM', header: 'L/mil', width: 15 }
  const co2Emission = { key: 'co2Emission', header: 'CO2', width: 15 }
  const nOXEmission = { key: 'nOXEmission', header: 'NOX', width: 15 }
  const consolidatedInvoiceAgreement = { key: 'consolidatedInvoiceAgreement', header: 'Samlefaktura', width: 15 }

  return [
    year,
    regNo,
    vehicleID,
    invoiceGroup,
    carDescription,
    totalKm,
    volume,
    fuelType,
    litersPerTenKm,
    co2Emission,
    nOXEmission,
    consolidatedInvoiceAgreement,
  ]
}
